<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        Pro User Agreement
      </content-page-title>
    </template>

    <div class="pa-2 white rounded-lg">
      <ProEULA />
    </div>
  </ContentPage>
</template>


<script>
import { ContentPage, ContentPageTitle } from '@/components/pages'
import ProEULA from '@/components/documents/ProTOS_2025_08_28'

export default {
  name: 'LoginEULA',

  components: { ContentPage, ContentPageTitle, ProEULA },
}
</script>
